export default class RedirectionSignal {
  constructURL () {
    throw new Error("constructURL() method is not overwritten")
  }
  redirect (hash, jwts) {
    window.location.replace(this.constructURL(hash, jwts))
  }
}
